/*
  Session recordings (Microsoft Clarity) only start after a yes. The portal calls clarity.consent()
  silently after login; a parent app around children's data asks first. The choice is kept per
  device and can be changed in Settings.
*/
import { Button } from "app/components/v1/Button";
import storage, { STORAGE_KEYS } from "app/utils/storage";
import { useState } from "react";
import { clarity } from "react-microsoft-clarity";

export type Consent = "yes" | "no" | null;
export const getConsent = (): Consent => (storage.getItem(STORAGE_KEYS.CONSENT) as Consent) ?? null;

export function applyConsent(value: Exclude<Consent, null>) {
  storage.setItem(STORAGE_KEYS.CONSENT, value);
  const id = process.env.REACT_APP_MS_CLARITY;
  if (!id) return;
  try {
    if (value === "yes") { if (!clarity.hasStarted()) clarity.init(id); clarity.consent(); }
    else if (clarity.hasStarted()) (clarity as unknown as { stop?: () => void }).stop?.();
  } catch { /* Clarity script blocked: nothing to do */ }
}

export default function ConsentBanner() {
  const [consent, setConsent] = useState<Consent>(getConsent());
  if (consent !== null || !process.env.REACT_APP_MS_CLARITY) return null;
  const choose = (v: "yes" | "no") => { applyConsent(v); setConsent(v); };
  return (
    <div className="ct-card p-3 mb-3" role="dialog" aria-label="Help us improve">
      <div style={{ fontWeight: 700, color: "#171725" }}>Help us improve the app?</div>
      <p className="ct-muted mb-2" style={{ fontSize: 13 }}>We can record how screens are used (never what you type) to fix problems faster. Your choice can be changed in Settings.</p>
      <div className="d-flex gap-2">
        <Button size="sm" name="Yes, that's fine" onClick={() => choose("yes")} />
        <Button size="sm" buttonType="outlined" color="secondary" name="No thanks" onClick={() => choose("no")} />
      </div>
    </div>
  );
}
